import { langResources } from "../language/index";

const createShortcut = (shortcutKey, en, tr) => ({
    shortcutKey,
    en,
    tr,
    ru: en,
});

const shortcutAll = [
    createShortcut("CTRL + M", langResources.en.message.openPrivateChat, langResources.tr.message.openPrivateChat),
    createShortcut("CTRL + ↑", langResources.en.message.closeActiveChat, langResources.tr.message.closeActiveChat),
    createShortcut(
        "CTRL + →",
        langResources.en.message.nextChatFromActive,
        langResources.tr.message.nextChatFromActive
    ),
    createShortcut(
        "CTRL + ←",
        langResources.en.message.previousChatFromActive,
        langResources.tr.message.previousChatFromActive
    ),
    createShortcut("CTRL + ↓", langResources.en.message.hideActiveChat, langResources.tr.message.hideActiveChat),
    createShortcut("ESC", langResources.en.message.escKey, langResources.tr.message.escKey),
    createShortcut("F1", langResources.en.message.focusInput, langResources.tr.message.focusInput),
    createShortcut("F2", langResources.en.message.firsthiddenChat, langResources.tr.message.firsthiddenChat),
    createShortcut("F3", langResources.en.message.firstChatWaiting, langResources.tr.message.firstChatWaiting),
    createShortcut("F4", langResources.en.message.previousOpenedChat, langResources.tr.message.previousOpenedChat),
    createShortcut("#hash", langResources.en.message.hashHintMessage, langResources.tr.message.hashHintMessage),
    createShortcut("PM", langResources.en.message.pmHintMessage, langResources.tr.message.pmHintMessage),
    createShortcut("", langResources.en.message.shortcutHintMessage, langResources.tr.message.shortcutHintMessage),
    createShortcut("`CTRL + ,", langResources.en.message.chatCopilot, langResources.tr.message.chatCopilot),
    createShortcut(
        "1,2,3",
        langResources.en.message.switchBetweenConversations,
        langResources.tr.message.switchBetweenConversations
    ),
    createShortcut("@name", langResources.en.message.atNameHintMessage, langResources.tr.message.atNameHintMessage),
    createShortcut("", langResources.en.message.dndHintMessage, langResources.tr.message.dndHintMessage),
    createShortcut("CTRL + V", langResources.en.message.pasteFile, langResources.tr.message.pasteFile),
    createShortcut("@email", langResources.en.message.atEmailHintMessage, langResources.tr.message.atEmailHintMessage),
    createShortcut(
        "CTRL + SHIFT + V",
        langResources.en.message.pastePlainText,
        langResources.tr.message.pastePlainText
    ),
    createShortcut(`CTRL + "`, langResources.en.message.pressAndTallk, langResources.tr.message.pressAndTallk),
];

const getRandomShortcut = () => {
    const randomIndex = ~~(Math.random() * shortcutAll.length);
    const defaultShortcut = createShortcut(
        "F1",
        langResources.en.message.focusInput,
        langResources.tr.message.focusInput
    );
    return shortcutAll[randomIndex] || defaultShortcut;
};

export default getRandomShortcut;
